import React from "react";
import "./Spinner.css";
function Spinner(props) {
  const visible = props.style && props.style !== "none";
  return (
    <div
      id={props.id}
      className={`spinner_loading${visible ? " spinner_loading--visible" : ""}`}
    />
  );
}

export default Spinner;
